import { render, staticRenderFns } from "./MyTasksCard.vue?vue&type=template&id=754af2aa"
import script from "./MyTasksCard.vue?vue&type=script&lang=ts"
export * from "./MyTasksCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports